<template>
	<div class="main" v-loading.fullscreen="isLoad" element-loading-background="rgba(0, 0, 0,0)">
		<el-breadcrumb separator-class="el-icon-arrow-right">
			<el-breadcrumb-item>商品管理</el-breadcrumb-item>
			<el-breadcrumb-item>在售商品</el-breadcrumb-item>
		</el-breadcrumb>
		<el-form :inline="true" :model="item" class="search">
			<el-form-item label="商品名称">
				<el-input v-model="item.name" placeholder="请输入商品名称" size="small"></el-input>
			</el-form-item>
			<el-form-item label="来源">
				<el-select v-model="item.from" size="small">
					<el-option label="全部" value="0"></el-option>
					<el-option label="自有" value="1"></el-option>
					<el-option label="产品库" value="2"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="商品分类">
				<el-cascader v-model="item.store_category_id"  placeholder="请选择"
					:options="optionsProduct" :props="filterProps" clearable></el-cascader>
			</el-form-item>
			<el-form-item>
				<el-button type="primary" @click="submit" size="medium">查询</el-button>
<!--				<el-button type="primary" @click="excelOut" size="medium">批量导入</el-button>-->
				<el-button type="primary" @click="excelOut" size="medium">批量导出</el-button>
				<el-button type="primary" @click="find" size="medium">推荐至热门商品</el-button>
			</el-form-item>
		</el-form>
		<!--		:data="list"数据-->
		<el-table :data="list" border @selection-change="handleSelectionChange">
			<!--			这里 prop scope传值-->
			<el-table-column type="selection" align="center"></el-table-column>
			<el-table-column width="60" align="center">
				<template slot-scope="scope">
					{{scope.$index + (page-1) * pageSize + 1}}
				</template>
			</el-table-column>

			<el-table-column prop="name" label="名称"></el-table-column>
			<el-table-column label="商品图片">
				<!--				商品的组件和插槽-->
				<template slot-scope="scope">
					<div style="display: flex; align-items: center;">
						<img :src="scope.row.product_pic_main" height="30" style="display: flex; margin-right: 5px;" />
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="category" label="商品分类">
				<template slot-scope="scope" v-if="scope.row.category">
					{{scope.row.category.name}}
				</template>
			</el-table-column>
			<el-table-column label="浏览量">
				<template slot-scope="scope">
					{{scope.row.view_num}}
				</template>
			</el-table-column>
			<el-table-column label="金额" align="center" width="160">
				<!--			价格模板插槽	-->
				<template slot-scope="scope">
					<div>
						最低：￥{{scope.row.price_min}}
					</div>
					<div>
						最高：￥{{scope.row.price_max}}
					</div>
				</template>
			</el-table-column>
			<el-table-column label="商品来源" align="center">
				<!--			价格模板插槽	-->
				<template slot-scope="scope">
					<div v-if="scope.row.in_store">
						自有商品
					</div>
					<div v-else>
						<div>供应商商品</div>
						<div style="margin-top: 10px">加价：<span style="color: red;">{{scope.row.price}}元</span></div>
					</div>
				</template>
			</el-table-column>
			<el-table-column label="状态" align="center">
				<!--			价格模板插槽	-->
				<template slot-scope="scope">
					<el-tag size="small" type="success" v-if="scope.row.is_marketable">
						已上架
					</el-tag>
					<el-tag size="small" type="danger" v-else>
						已下架
					</el-tag>
				</template>
			</el-table-column>
			<el-table-column prop="created_date" label="添加时间" align="center"></el-table-column>
			<el-table-column prop="last_modified_date" label="更新时间" align="center"></el-table-column>
			<el-table-column label="操作" width="280">
				<template slot-scope="scope">
					<!--					传ID过去修改-->
					<el-button size="mini" type="primary" @click="edit(scope.row.goods_id,scope.row.type)">查看
					</el-button>
					<el-popconfirm title="您确定下架吗？" @confirm="changeMarkeOff(scope.row.goods_id,scope.row.type)"
						class="l10" v-auth="['store/product/putonandoff']">
						<el-button size="mini" type="warning" slot="reference">下架</el-button>
					</el-popconfirm>
					<el-button style="margin-left: 10px;" v-if="scope.row.in_store" size="mini" type="primary"
							   @click="changePrice2(scope.row.goods_id, scope.row.name)" v-auth="['supplier/product/edit']">修改价格</el-button>
					<el-button style="margin-left: 10px;" v-if="!scope.row.in_store" size="mini" type="primary"
						@click="changePrice(scope.row,scope.row.goods_id)" v-auth="['store/product/price']">修改上架信息</el-button>
				</template>
			</el-table-column>
		</el-table>
		<!-- 价格 -->
		<el-dialog title="修改价格" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
			<span>
				<span>商品名称：{{propName}}</span>
				<span style="margin-left: 20px;color: red">原金额：{{propPrice}}</span>
				<span style="display: flex;align-items: center;margin-top: 20px;">
					<span style="flex-shrink: 0;margin-right: 10px;">分类</span>
					<el-cascader v-model="selectStoreCategory" placeholder="请选择" :options="optionsProduct"
						 :props="filterProps" clearable>
					</el-cascader>
				</span>
				<span style="display: flex;align-items: center;margin-top: 20px;">
					<span style="flex-shrink: 0;margin-right: 10px;">提价金额(元)</span>
					<el-input v-model="price" placeholder="提价金额" style="flex-grow: 1;"></el-input>
				</span>
				<span style="display: flex;align-items: center;margin-top: 20px;">
					<span style="flex-shrink: 0;margin-right: 10px;">赠送积分</span>
					<el-input v-model="give_jifen" placeholder="" style="flex-grow: 1;"></el-input>
				</span>
				<span style="display: flex;align-items: center;margin-top: 20px;">
					<span style="flex-shrink: 0;margin-right: 10px;">是否开启积分兑换</span>
					<el-switch v-model="is_points" active-value="1" inactive-value="0" active-color="#13ce66" inactive-color="#cccccc">
						</el-switch>
				</span>
			</span>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="sureSub">确 定</el-button>
			</span>
		</el-dialog>
		<!--		页码-->
		<el-pagination @size-change="sizeReload" @current-change="pageReload" :current-page="page"
			:current-page.sync="pageNum" :page-sizes="[20, 100, 200, 300, 400]" :page-size="pageSize"
			layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
	</div>
</template>
<script>
	export default {
		name: 'Menu',
		data() {
			return {
				// 商品数据
				list: [],
				isLoad: false,
				pageSize: 20,
				pageNum: 0,
				total: 0,
				page: 1,
				thumb: [],
				// 查询
				item: {},
				optionsShop: [],
				optionsProduct: [],
				dialogVisible: false,
				categoryDialogVisible: false,
				propId:'',
				propName: '',
				propPrice: '',
				price: '',
				give_jifen: 0,
				is_points: 0,
				multipleSelection:[],
				filterProps: {
					value: 'id',
					label: 'name',
					emitPath: false,
					checkStrictly: true
				},
				selectStoreCategory: ''
			}
		},
		created() {
			this.item = {
					page: this.page,
					limit: this.pageSize,
					is_marketable: 1
				},
				this.getData()
			this.loadList()
		},
		methods: {
			getData() {
				// 获取商品分类
				this.axios.get('/store/data/getCategoryTreeStore', {}).then(res => {
					this.optionsProduct = res.data.list
				})
			},
			changeCategory(data) {
				this.categoryDialogVisible = true;
			},
			// 获取数据
			loadList() {
				if (this.isLoad) {
					return
				}
				this.isLoad = !this.isLoad
				//	将页码传到/Goods/index
				this.axios.post('/store/product/listOnSale', this.item)
				.then(res => {
					console.log(res);
					this.isLoad = !this.isLoad
					// 后端返回的商品数据列表
					this.list = res.data.list.data
					this.total = res.data.list.total
				})
				.catch(() => {
					this.isLoad = !this.isLoad
				})
			},
			changePrice(row,id) {
				this.dialogVisible = true
				this.propName = row.name
				this.propPrice = row.price
				this.price = row.price
				this.give_jifen = row.give_jifen
				this.propId = id
				this.is_points = row.is_points.toString()
				this.selectStoreCategory = row.store_category_id
			},
			changePrice2(id,name) {
				this.$router.push({
					path: '/Goods/price.html',
					query: {
						id: id,
						name:name
					}
				});
			},
			handleClose(done) {
				this.dialogVisible = false
				this.price = ''
			},
			sureSub() {
				this.price = parseFloat(this.price)
				this.axios.post('/store/product/updatePriceOnSale', {
					id: this.propId,
					price: this.price,
					give_jifen: this.give_jifen,
					is_points: this.is_points,
					store_category_id: this.selectStoreCategory
				})
				.then(() => {
					this.price = ''
					this.selectStoreCategory = ''
					this.$message.success({
						message: '操作成功'
					});
					this.loadList()
					this.dialogVisible = false
				})
				.catch(() => {
					this.price = ''
					this.selectStoreCategory = ''
				})
			},
			// 下架商品
			changeMarkeOff(productId, type) {
				if (this.isLoad) {
					return
				}
				this.isLoad = !this.isLoad
				let url = '/store/product/putOff'

				this.axios.post(url, {
					id: productId,
				}).then(res => {
					this.isLoad = !this.isLoad
					this.$message.success({
						message: '操作成功',
						showClose: false
					});
					// 重新获取数据
					this.loadList()
				}).catch(() => {
					this.isLoad = !this.isLoad
				})
			},
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},
			find() {
				let productId = []
				for(let key in this.multipleSelection){
				    let item = this.multipleSelection[key]
				    productId.push(item.goods_id)
				}
				this.axios.post('/store/product/addToFind', {
				    ids: productId
				}).then(() => {
					this.$message.success({
						message: '添加成功',
						showClose:false
					});
					this.loadList()
				})
				.catch(() => {
				})
			},
			// 带着商品ID跳转
			edit(productId, type) {
				// source区分来自店铺还是供应商
				let path = ''
				if (type == 1) {
					path = '/Goods/edit.html'
				} else {
					path = '/Goods/supplierEdit.html'
				}
				this.$router.push({
					path: '/Goods/edit.html',
					query: {
						id: productId,
						op: 2
					}
				});
			},
			//sizeReload 共多少条为一页
			sizeReload(val) {
				this.item.pageSize = val
				this.loadList()
			},
			// 前往第几页
			pageReload(val) {
				this.item.page = val
				this.loadList()
			},
			// 搜索查询
			submit() {
				this.pageNum = 1
				this.item.page = 1
				this.loadList()
			},
			// 导出
			// 导出
			excelOut() {
				if (this.isLoad) {
					return false
				}

				this.isLoad = !this.isLoad
				setTimeout(function () {
					this.isLoad = false
				}.bind(this), 100000);
				this.axios.post('/store/product/listOnSaleExport', this.item)
						.then(res => {
							this.isLoad = false
							if (res.code == 1) {
								import('@/vendor/Export2Excel.js').then(excel => {
									var expCellName = res.data.expCellName
									var tHeader = []
									var filterVal = []
									for (var i in expCellName) {
										tHeader.push(expCellName[i])
										filterVal.push(i)
									}
									const expTableData = res.data.expTableData
									const data = this.formatJson(filterVal, expTableData)
									var d = new Date()
									var year = d.getFullYear()
									var month = d.getMonth()
									var date = d.getDate()
									var hour = d.getHours()
									var minute = d.getMinutes()
									var second = d.getSeconds()
									month = month < 10 ? '0' + month : month
									date = date < 10 ? '0' + date : date
									hour = hour < 10 ? '0' + hour : hour
									minute = minute < 10 ? '0' + minute : minute
									second = second < 10 ? '0' + second : second
									excel.export_json_to_excel({
										header: tHeader,
										data,
										filename: '在售商品列表_' + year + '' + month + '' + date + '' + hour + '' + minute + '' + second,
										autoWidth: this.autoWidth,
										bookType: this.bookType
									})
								})
							} else {
								this.$message({
									message: res.msg,
									type: 'error',
									duration: 3 * 1000
								})
							}
						})
			},
			formatJson (filterVal, jsonData) {
				return jsonData.map(v => filterVal.map(j => {
					return v[j]
				}))
			},
		}
	}
</script>
<style scoped>
</style>
